'use client'

import { useEffect, useRef, useState } from 'react'
import cx from 'classnames'
import s from './expandable-wrapper.module.scss'
import { ClampButton } from '@/components/v3/atoms/clamp-button/clamp-button'

type Props = {
  children: React.ReactNode
  maxLines: number
  lineHeight: number
  gap: string
  className?: string
}

export const ExpandableWrapper = ({
  children,
  maxLines,
  lineHeight,
  gap,
  className,
}: Props) => {
  const [expanded, setExpanded] = useState(false)
  const [canExpand, setCanExpand] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref.current) return
    setCanExpand(ref.current.scrollHeight > ref.current.clientHeight)
  }, [children])

  return (
    <div className={cx(s.container, className)}>
      <div
        ref={ref}
        className={cx(s.content)}
        style={{
          lineHeight: `${lineHeight}px`,
          maxHeight: expanded ? 'none' : `calc(${lineHeight * maxLines}px )`,
          gap,
        }}
      >
        {children}
      </div>

      {canExpand && (
        <span className={s.clampButton}>
          <ClampButton
            isOpen={expanded}
            onClick={() => setExpanded((v) => !v)}
            text={expanded ? 'Show Less' : 'Show More'}
          />
        </span>
      )}
    </div>
  )
}
